import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { padWithZeros, sortFloors } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../partials/custom_date_picker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReportTabs from './report_tabs';

const KpiCard = ({ label, value, icon, color = '#00C6FE', sub }) => (
    <div className="bg-gray-2 p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 140, borderLeft: `3px solid ${color}` }}>
        <div className="d-flex align-items-center justify-content-between mb-1">
            <span className="gray font-10 poppins">{label}</span>
            {icon && <i className={`${icon} font-12`} style={{ color }} />}
        </div>
        <span className="white poppins toBold" style={{ fontSize: '1.7rem', lineHeight: 1 }}>{value}</span>
        {sub && <span className="font-10 mt-1 poppins" style={{ color }}>{sub}</span>}
    </div>
);

const PAGE_SIZE = 20;

class GuestsReport extends React.Component {
    state = {
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        filters: {
            CheckIn: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').utc(),
            CheckOut: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').add(1, 'days').utc(),
            IdStatus: null,
            Nationality: null,
            Civil: null,
            Company: null,
        },
        search: '',
        page: 0,
        pickStatus: false,
        pickNationality: false,
        pickCivil: false,
        pickCompany: false,
    }

    componentWillMount() {
        const { params } = this.props;
        let user = fakeAuth.getUser();
        if (user.Permissions & (config.permissions.SuperAdmin | config.permissions.Reports) === 0) {
            this.props.router.goBack();
        } else {
            this.props.properties_actions && this.props.properties_actions.fetch_one(params.id);
            this.props.floors_actions && this.props.floors_actions.fetch(params.id);
            this.props.rooms_actions && this.props.rooms_actions.fetch(params.id);
            this.props.properties_actions && this.props.properties_actions.fetch_guests(params.id, 'blst');
            this.onFetch();
        }
    }

    componentWillReceiveProps = nextProps => {
        const { floors = [], bookings, rooms, guests } = nextProps;

        if (guests !== this.props.guests) {
            this.setState({ blacklist: (guests || []).filter(g => parseInt(g.IsBlacklisted, 10) === 1) });
        }

        if (!rooms) return;

        let all_booked_rooms = _.chain(bookings)
            .filter(b => moment(b.CheckIn).isBetween(this.state.filters.CheckIn, this.state.filters.CheckOut))
            .filter(b => [3, 4].indexOf(parseInt(b.IdStatus, 10)) !== -1)
            .each(b => {
                b.Rooms.forEach(room => _.extend(room, _.pick(b, 'PNR', 'GivenName', 'Guests', 'Accounting')));
                b.Guests.forEach(g => _.extend(g, _.pick(b, 'PNR', 'GivenName', 'CheckIn', 'CheckOut', 'IdStatus', 'CoorporateName')));
            })
            .map(b => b.Rooms).flatten().compact().value();

        let resources = [];
        sortFloors(floors).forEach(floor => {
            _.sortBy(floor.Pieces, 'Label').forEach(piece => {
                resources.push({
                    id: piece.IdPiece,
                    title: piece.Label,
                    name: (_.find(rooms, r => r.IdRoom === piece.IdRoom) || {}).GivenName,
                    IdRoom: (_.find(rooms, r => r.IdRoom === piece.IdRoom) || {}).IdRoom,
                    BOOK: _.find(all_booked_rooms, br => br.IdPiece === piece.IdPiece),
                });
            });
        });

        const people = _.chain(bookings)
            .filter(b => moment(b.CheckIn).isBetween(this.state.filters.CheckIn, this.state.filters.CheckOut))
            .filter(b => [3, 4].indexOf(parseInt(b.IdStatus, 10)) !== -1)
            .map(b => b.Guests).flatten().compact()
            .each(user => {
                if (user.IdBookRoom || user.IdBookRoom_BURN) {
                    user.BOOKED_ROOM = _.find(all_booked_rooms, abr => abr.IdBookRoom === (user.IdBookRoom || user.IdBookRoom_BURN));
                }
            })
            .value();

        const nationalities = _.chain(people).map(p => p.Nationality).uniq().compact().sortBy().value();
        const civils = _.chain(people).map(p => p.Civil).uniq().compact().sortBy().value();
        const companies = _.chain(people).map(p => p.CoorporateName).uniq().compact().sortBy().value();

        this.setState({
            page: 0,
            bookings: _.chain(bookings)
                .filter(b => moment(b.CheckIn).isBetween(this.state.filters.CheckIn, this.state.filters.CheckOut))
                .filter(b => [3, 4].indexOf(parseInt(b.IdStatus, 10)) !== -1)
                .value(),
            all_booked_rooms,
            people,
            resources,
            nationalities,
            civils,
            companies,
            bootstrapped: !!bookings,
        });
    }

    onFetch = () => {
        this.props.booking_actions && this.props.booking_actions.fetch_range({
            IdProperty: this.props.params.id,
            CheckIn: moment(this.state.filters.CheckIn).format('YYYY-MM-DD'),
            CheckOut: moment(this.state.filters.CheckOut).format('YYYY-MM-DD'),
        });
    }

    getFiltered = () => {
        const { people, filters, search } = this.state;
        if (!people) return [];
        return _.chain(people)
            .filter(r => filters.IdStatus ? parseInt(r.IdStatus, 10) === filters.IdStatus : true)
            .filter(r => filters.Nationality ? r.Nationality === filters.Nationality : true)
            .filter(r => filters.Civil ? r.Civil === filters.Civil : true)
            .filter(r => filters.Company ? r.CoorporateName === filters.Company : true)
            .filter(r => {
                if (!search) return true;
                const s = search.toLowerCase();
                return [r.FirstName, r.LastName, r.Nationality, r.IdOrPassport, r.Profession,
                        r.Occupation, r.Origin, r.Destination, r.Civil, r.CoorporateName,
                        r.GivenName, r.PNR ? String(r.PNR) : null]
                    .filter(Boolean).some(v => v.toLowerCase().includes(s));
            })
            .sortBy(u => u.Nationality !== 'Venezolana')
            .value();
    }

    renderHeader = () => (
        <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_reportes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Reportes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    )

    safeAge = (dob) => {
        if (!dob) return null;
        const s = String(dob);
        // Try strict YYYY-MM-DD first (covers '1991-04-19' and '1991-04-19 00:00:00')
        let m = moment(s.split('T')[0].split(' ')[0], 'YYYY-MM-DD', true);
        // Fall back to native Date parsing (covers 'Tue Aug 09 1988 00:00:00 GMT-0400 (...)')
        if (!m.isValid()) m = moment(new Date(s));
        if (!m.isValid()) return null;
        const age = moment().diff(m, 'years');
        return isNaN(age) ? null : age;
    }

    renderKpis = () => {
        const { people } = this.state;
        const filtered = this.getFiltered();
        if (!people) return null;

        const total = filtered.length;
        const ages = filtered.map(p => this.safeAge(p.DateOfBirth)).filter(a => a !== null);
        const avgAge = ages.length ? Math.round(_.sum(ages) / ages.length) : '-';
        const countries = _.chain(filtered).map(p => p.Nationality).uniq().compact().value().length;
        const checkedIn = filtered.filter(p => parseInt(p.IdStatus, 10) === 3).length;

        return (
            <div className="d-flex flex-wrap mt-3 mb-2" style={{ gap: 10 }}>
                <KpiCard label="Total huéspedes" value={total} icon="fas fa-users" color="#00C6FE" />
                <KpiCard label="Checked-in" value={checkedIn} icon="fas fa-sign-in-alt" color="#00c97a" />
                <KpiCard label="Edad promedio" value={avgAge} icon="fas fa-birthday-cake" color="#6E44FF" sub="años" />
                <KpiCard label="Nacionalidades" value={countries} icon="fas fa-globe" color="#FFC107" />
            </div>
        );
    }

    renderFilters = () => {
        const { filters, nationalities = [], civils = [], companies = [] } = this.state;
        const selectedStatus = _.find(config.booking_status, s => s.id === filters.IdStatus);

        return (
            <Animated animationIn="fadeInDown" animationInDuration={200} className="d-flex flex-wrap align-items-flex-end mt-3 mb-2" style={{ gap: 10 }}>

                {/* CheckIn */}
                <div style={{ minWidth: 140 }}>
                    <label className="white poppins font-11 d-block mb-1">Entrada</label>
                    <DatePicker
                        selected={filters.CheckIn}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Desde" />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        maxDate={filters.CheckOut}
                        onChange={date => {
                            const { filters } = this.state;
                            filters.CheckIn = moment(date).utc();
                            this.setState({ filters, page: 0 }, this.onFetch);
                        }}
                    />
                </div>

                {/* CheckOut */}
                <div style={{ minWidth: 140 }}>
                    <label className="white poppins font-11 d-block mb-1">Salida</label>
                    <DatePicker
                        selected={filters.CheckOut}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Hasta" clear={() => {
                            const { filters } = this.state;
                            filters.CheckOut = null;
                            this.setState({ filters });
                        }} />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        minDate={filters.CheckIn}
                        onChange={date => {
                            const { filters } = this.state;
                            filters.CheckOut = moment(date).utc();
                            this.setState({ filters, page: 0 }, this.onFetch);
                        }}
                    />
                </div>

                {/* Booking status */}
                <div style={{ minWidth: 160 }}>
                    <label className="white poppins font-11 d-block mb-1">Estado</label>
                    <div className="black-input d-flex">
                        <Dropdown isOpen={this.state.pickStatus} toggle={() => this.setState({ pickStatus: !this.state.pickStatus })} className="w-100">
                            <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                <span className="align-self-center font-12">{selectedStatus ? selectedStatus.name : 'Todos'}</span>
                                <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                                <DropdownItem onClick={() => { const { filters } = this.state; filters.IdStatus = null; this.setState({ filters, page: 0, pickStatus: false }); }}>Todos</DropdownItem>
                                {[{ id: 3, name: 'Checked-in' }, { id: 4, name: 'Checked-out' }].map((s, i) => (
                                    <DropdownItem key={i} onClick={() => {
                                        const { filters } = this.state;
                                        filters.IdStatus = s.id;
                                        this.setState({ filters, page: 0, pickStatus: false });
                                    }}>{s.name}</DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>

                {/* Nationality */}
                {nationalities.length > 0 && (
                    <div style={{ minWidth: 180 }}>
                        <label className="white poppins font-11 d-block mb-1">Nacionalidad</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickNationality} toggle={() => this.setState({ pickNationality: !this.state.pickNationality })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">{filters.Nationality || 'Todas'}</span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100" style={{ maxHeight: 260, overflowY: 'auto' }}>
                                    <DropdownItem onClick={() => { const { filters } = this.state; filters.Nationality = null; this.setState({ filters, page: 0, pickNationality: false }); }}>Todas</DropdownItem>
                                    {nationalities.map((n, i) => (
                                        <DropdownItem key={i} onClick={() => {
                                            const { filters } = this.state;
                                            filters.Nationality = n;
                                            this.setState({ filters, page: 0, pickNationality: false });
                                        }}>{n}</DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                {/* Civil status */}
                {civils.length > 0 && (
                    <div style={{ minWidth: 160 }}>
                        <label className="white poppins font-11 d-block mb-1">Estado civil</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickCivil} toggle={() => this.setState({ pickCivil: !this.state.pickCivil })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">{filters.Civil || 'Todos'}</span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100">
                                    <DropdownItem onClick={() => { const { filters } = this.state; filters.Civil = null; this.setState({ filters, page: 0, pickCivil: false }); }}>Todos</DropdownItem>
                                    {civils.map((c, i) => (
                                        <DropdownItem key={i} onClick={() => {
                                            const { filters } = this.state;
                                            filters.Civil = c;
                                            this.setState({ filters, page: 0, pickCivil: false });
                                        }}>{c}</DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                {/* Company */}
                {companies.length > 0 && (
                    <div style={{ minWidth: 180 }}>
                        <label className="white poppins font-11 d-block mb-1">Empresa</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickCompany} toggle={() => this.setState({ pickCompany: !this.state.pickCompany })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">{filters.Company || 'Todas'}</span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100" style={{ maxHeight: 260, overflowY: 'auto' }}>
                                    <DropdownItem onClick={() => { const { filters } = this.state; filters.Company = null; this.setState({ filters, page: 0, pickCompany: false }); }}>Todas</DropdownItem>
                                    {companies.map((c, i) => (
                                        <DropdownItem key={i} onClick={() => {
                                            const { filters } = this.state;
                                            filters.Company = c;
                                            this.setState({ filters, page: 0, pickCompany: false });
                                        }}>{c}</DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                {/* Search */}
                <div style={{ minWidth: 200, flex: 1 }}>
                    <label className="white poppins font-11 d-block mb-1">Buscar</label>
                    <div className="bg-gray-2 black-input d-flex">
                        <i className="fas fa-search font-14 white align-self-center ps-3" />
                        <input className="w-100 p-3 white font-12" type="text" placeholder="Nombre, ID, destino..."
                            onChange={e => this.setState({ search: e.target.value, page: 0 })} />
                    </div>
                </div>

                {this.state.bootstrapped && (
                    <div style={{ alignSelf: 'flex-end', display: 'flex', gap: 10 }}>
                        <ReactHTMLTableToExcel
                            id="guests-xls"
                            className="btn btn-link white bordered d-flex align-items-center px-3"
                            style={{ height: 46 }}
                            table="guests-table-xls"
                            filename="Huespedes"
                            sheet="Huespedes"
                            buttonText={<><i className="fas fa-file-excel font-14 me-2" /><span className="poppins font-12">Exportar</span></>}
                        />
                        <ReactHTMLTableToExcel
                            id="blacklist-xls"
                            className="btn btn-link white bordered d-flex align-items-center px-3"
                            style={{ height: 46 }}
                            table="blacklist-table-xls"
                            filename="Blacklist"
                            sheet="Blacklist"
                            buttonText={<><i className="fas fa-file-excel font-14 me-2" /><span className="poppins font-12">Exportar Blacklist</span></>}
                        />
                    </div>
                )}
            </Animated>
        );
    }

    renderRow = (r, index) => (
        <tr key={index}>
            <td>{index + 1}</td>
            <td>{r.PieceLabel_BURN || (r.BOOKED_ROOM ? r.BOOKED_ROOM.PieceLabel : '-')}</td>
            <td>{moment(r.CheckIn).format('DD/MM/YYYY')}</td>
            <td>{r.FirstName}</td>
            <td>{r.LastName}</td>
            <td>{this.safeAge(r.DateOfBirth) !== null ? this.safeAge(r.DateOfBirth) : '-'}</td>
            <td>{r.Nationality}</td>
            <td>{r.Civil || 'Solter@'}</td>
            <td>{r.Profession || r.Occupation}</td>
            <td>{r.Origin}</td>
            <td>{r.IdOrPassport}</td>
            <td>{moment(r.CheckOut).format('DD/MM/YYYY')}</td>
            <td>{r.Destination}</td>
        </tr>
    )

    renderTHead = () => (
        <thead>
            <tr>
                <th>#</th>
                <th>Hab</th>
                <th>Entrada</th>
                <th>Nombre(s)</th>
                <th>Apellido(s)</th>
                <th>Edad</th>
                <th>Nacionalidad</th>
                <th>E. Civil</th>
                <th>Profesión</th>
                <th>Procedencia</th>
                <th>ID / Pasaporte</th>
                <th>Salida</th>
                <th>Destino</th>
            </tr>
        </thead>
    )

    renderBlacklistTHead = () => (
        <thead>
            <tr>
                <th>#</th>
                <th>Nombre(s)</th>
                <th>Apellido(s)</th>
                <th>ID / Pasaporte</th>
                <th>Fecha de incorporación</th>
                <th>Motivo</th>
            </tr>
        </thead>
    )

    renderBlacklistRow = (r, index) => (
        <tr key={index}>
            <td>{index + 1}</td>
            <td>{r.FirstName}</td>
            <td>{r.LastName}</td>
            <td>{r.IdOrPassport}</td>
            <td>{r.BlacklistDate ? moment(r.BlacklistDate).format('DD/MM/YYYY') : '-'}</td>
            <td>{r.BlacklistMotivo}</td>
        </tr>
    )

    renderTable = () => {
        const { page } = this.state;
        const filtered = this.getFiltered();
        const total_pages = Math.ceil(filtered.length / PAGE_SIZE);
        const page_data = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

        return (
            <div>
                {/* Hidden full table for Excel */}
                <table className="table font-10" id="guests-table-xls" style={{ display: 'none' }}>
                    {this.renderTHead()}
                    <tbody>{filtered.map((r, i) => this.renderRow(r, i))}</tbody>
                </table>

                {/* Hidden blacklist table for Excel */}
                <table className="table font-10" id="blacklist-table-xls" style={{ display: 'none' }}>
                    {this.renderBlacklistTHead()}
                    <tbody>{(this.state.blacklist || []).map((r, i) => this.renderBlacklistRow(r, i))}</tbody>
                </table>

                {/* Visible paginated table */}
                <table className="table font-10">
                    {this.renderTHead()}
                    <tbody>
                        {page_data.length === 0 && (
                            <tr><td colSpan={13} className="text-center gray poppins py-4">No se encontraron huéspedes con los filtros seleccionados.</td></tr>
                        )}
                        {page_data.map((r, i) => this.renderRow(r, page * PAGE_SIZE + i))}
                    </tbody>
                </table>

                {total_pages > 1 && (
                    <div className="d-flex justify-content-center align-items-center mt-3 mb-2" style={{ gap: 6 }}>
                        <button className="btn btn-link poppins font-12" style={{ color: page === 0 ? '#444' : '#008db5' }}
                            disabled={page === 0} onClick={() => this.setState({ page: 0 })}>
                            <i className="fas fa-angle-double-left" />
                        </button>
                        <button className="btn btn-link poppins font-12" style={{ color: page === 0 ? '#444' : '#008db5' }}
                            disabled={page === 0} onClick={() => this.setState({ page: page - 1 })}>
                            <i className="fas fa-angle-left" />
                        </button>

                        {_.range(total_pages).map(p => (
                            <button key={p} className="btn btn-link poppins font-12"
                                style={{ color: p === page ? '#fff' : '#555', fontWeight: p === page ? 700 : 400, minWidth: 28 }}
                                onClick={() => this.setState({ page: p })}>{p + 1}</button>
                        ))}

                        <button className="btn btn-link poppins font-12" style={{ color: page >= total_pages - 1 ? '#444' : '#008db5' }}
                            disabled={page >= total_pages - 1} onClick={() => this.setState({ page: page + 1 })}>
                            <i className="fas fa-angle-right" />
                        </button>
                        <button className="btn btn-link poppins font-12" style={{ color: page >= total_pages - 1 ? '#444' : '#008db5' }}
                            disabled={page >= total_pages - 1} onClick={() => this.setState({ page: total_pages - 1 })}>
                            <i className="fas fa-angle-double-right" />
                        </button>

                        <span className="poppins font-10 ms-2 gray">
                            {page * PAGE_SIZE + 1}–{Math.min((page + 1) * PAGE_SIZE, filtered.length)} de {filtered.length}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    renderCommon = () => {
        const { params } = this.props;
        return (
            <div>
                {this.renderHeader()}
                <ReportTabs active="guests" id={params.id} />

                <div style={{ position: 'absolute', top: '11em', bottom: 0, left: 100, right: 0, display: 'flex', flexDirection: 'column' }} className="bg-gray-dark">

                    {/* Top zone: KPIs + filters — no overflow so dropdowns show */}
                    <div className="px-3 pt-3" style={{ flexShrink: 0, position: 'relative', zIndex: 200 }}>
                        {this.renderKpis()}
                        {this.renderFilters()}
                    </div>

                    {/* Bottom zone: scrollable table */}
                    <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }} className="px-3 pb-3">
                        {this.state.bootstrapped && (
                            <Animated animationIn="fadeInUp" animationInDuration={200}>
                                <div className="bg-gray-2 p-3 mt-2" style={{ borderRadius: 6, width: '100%' }}>
                                    {this.renderTable()}
                                </div>
                            </Animated>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.microTransac && <LineLoader />}

                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        );
    }
}

export default GuestsReport;
